import { render } from "./PageTransition.vue?vue&type=template&id=220c82af&scoped=true"
import script from "./PageTransition.vue?vue&type=script&lang=js"
export * from "./PageTransition.vue?vue&type=script&lang=js"

import "./PageTransition.vue?vue&type=style&index=0&id=220c82af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220c82af"]])

export default __exports__